export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Store Locator"])},
        "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search by location"])},
        "enterPostalCode": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter your Zip Code"])}
      },
      "de": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filialsuche"])},
        "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nach Ort suchen"])}
      }
    }
  })
}